import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { camps } from '../../../models/models.generated';
import { CampCareBookingsCalendarEventService } from '../camp-care-booking-calendar/camp-care-bookings-calendar-event.service';



@Component({
    selector: 'app-camp-care-booking-criteria',
    templateUrl: './camp-care-booking-criteria.component.html',
    styleUrls: ['./camp-care-booking-criteria.component.scss'],
    standalone: false
})
export class CampCareBookingCriteriaComponent implements OnInit {

    @Input()
    public searchForm: UntypedFormGroup;

    @Input()
    public camp: camps.CampCareInfo;

    private selectedClub: camps.ClubInfo;

    constructor(private eventService: CampCareBookingsCalendarEventService) { }

    ngOnInit() {

    }

    public onSelectClub(club: camps.ClubInfo){
        this.selectedClub = club;

        this.searchForm.controls['clubId'].setValue(club.id);
        this.eventService.onRefreshCalendar();
    }

    public isClubSelected(club: camps.ClubInfo){
        if(!this.selectedClub)
            return false;

        return this.selectedClub.id == club.id;
    }
}
